import { createAction, props } from '@ngrx/store';
import { State } from 'src/app/shared/models/state';

export const loadStates = createAction('[DOCUMENT REVIEWER] Load States');
export const loadStatesSuccess = createAction('[DOCUMENT REVIEWER] Load States Success', props<{ states: State[] }>());
export const loadStatesFailure = createAction('[DOCUMENT REVIEWER] Load States Failure', props<{ error: unknown }>());
